import { Translation } from "../../../hooks/useTranslations";
import { formatBoolean } from "../../../utils";

export interface BooleanSelectValue {
  value: boolean;
  label: string;
}

export const getBooleanValues = (translations: Translation): BooleanSelectValue[] => [
  { value: true, label: formatBoolean(translations, true) },
  { value: false, label: formatBoolean(translations, false) },
];
